import { provide, shallowRef, type InjectionKey, type Ref } from 'vue'
import type { GeoJSONFeature } from 'mapbox-gl'
import { injectWithSelf } from '@/utils/injectWithSelf'

export type HoveredMapFeature = GeoJSONFeature

interface MapHoverContext {
  hoveredFeature: Ref<HoveredMapFeature | null>
  cursorPosition: Ref<[number, number] | null>
  setHoveredFeature: (feature: HoveredMapFeature | null) => void
}

const MapHoverContextKey = Symbol('map-hover-context') as InjectionKey<MapHoverContext>

export const useCreateMapHoverState = () => {
  const hoveredFeature = shallowRef<HoveredMapFeature | null>(null)
  const cursorPosition = shallowRef<[number, number] | null>(null)
  const setHoveredFeature = (feature: HoveredMapFeature | null) => {
    hoveredFeature.value = feature
    if (!feature) cursorPosition.value = null
  }

  const context: MapHoverContext = { hoveredFeature, cursorPosition, setHoveredFeature }
  provide(MapHoverContextKey, context)
  return context
}

export const useMapHover = () =>
  injectWithSelf<MapHoverContext>(MapHoverContextKey, () => ({
    hoveredFeature: shallowRef<HoveredMapFeature | null>(null),
    cursorPosition: shallowRef<[number, number] | null>(null),
    setHoveredFeature: () => {},
  }))
